export var Plugins;
(function(Plugins) {
    Plugins["EMOTES"] = 'Emotes';
    Plugins["IMAGE"] = 'Image';
    Plugins["GALLERY"] = 'Gallery';
    Plugins["VIDEO"] = 'Video';
    Plugins["LINK"] = "LINK";
    Plugins["LINK_PREVIEW"] = 'wix-draft-plugin-link-preview';
    Plugins["MENTION"] = 'Mention';
    Plugins["HASHTAG"] = 'Hashtag';
    Plugins["TEXT_COLOR"] = 'wix-rich-content-text-color';
    Plugins["HIGHLIGHT_COLOR"] = 'wix-rich-content-text-highlight';
    Plugins["GIPHY"] = 'wix-draft-plugin-giphy';
    Plugins["INDENT"] = 'wix-draft-plugin-indent';
    Plugins["SCROLLER"] = 'DaScroller';
    Plugins["DND_UPLOAD"] = 'DndUpload';
    Plugins["DIVIDER"] = 'wix-draft-plugin-divider';
    Plugins["EMOJI"] = 'wix-draft-plugin-emoji';
})(Plugins || (Plugins = {}));
